import { render, staticRenderFns } from "./SettingPageView.vue?vue&type=template&id=59e1bf67&"
import script from "./SettingPageView.vue?vue&type=script&lang=js&"
export * from "./SettingPageView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports